/** Mobile purchase shortcut. Reuses the real Dawn form; no second cart implementation. */
(() => {
  'use strict';
  if (customElements.get('af-signature-sticky')) return;
  customElements.define('af-signature-sticky', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.mainButton = this.root?.querySelector('[id^="ProductSubmitButton-"]');
      this.button = this.querySelector('[data-sticky-submit]');
      if (!this.root || !this.mainButton || !this.button || !('IntersectionObserver' in window)) return;
      this.price = this.querySelector('[data-sticky-price]');
      this.status = this.querySelector('[data-sticky-status]');
      this.media = window.matchMedia('(max-width: 749px)');
      this.pastButton = false;
      this.update = () => {
        const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        this.button.disabled = disabled;
        const text = this.mainButton.querySelector('span')?.textContent.trim() || this.mainButton.textContent.trim();
        if (this.button.textContent !== text) this.button.textContent = text;
        const container = this.root.querySelector('[id^="price-"] .price');
        const price = container?.querySelector(container.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
        const priceText = price?.textContent.trim() || '';
        if (this.price.textContent !== priceText) this.price.textContent = priceText;
        this.hidden = !(this.pastButton && this.media.matches);
      };
      this.onClick = () => { this.status.textContent = ''; if (!this.button.disabled) this.mainButton.click(); };
      this.button.addEventListener('click', this.onClick);
      this.media.addEventListener('change', this.update);
      this.observer = new IntersectionObserver(([entry]) => {
        this.pastButton = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        this.update();
      });
      this.observer.observe(this.mainButton);
      // IntersectionObserver can miss an instantaneous jump from below to above
      // the viewport when both positions have zero intersection. Check once per frame.
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.pastButton = this.mainButton.getBoundingClientRect().bottom <= 0;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll, {passive:true});
      this.mutations = new MutationObserver(() => {
        this.update();
        const wrapper = this.root.querySelector('.product-form__error-message-wrapper');
        const message = wrapper && !wrapper.hidden ? wrapper.textContent.trim() : '';
        if (this.status.textContent !== message) this.status.textContent = message;
      });
      this.mutations.observe(this.mainButton, {attributes:true, childList:true, subtree:true, characterData:true});
      const price = this.root.querySelector('[id^="price-"]');
      if (price) this.mutations.observe(price, {childList:true,subtree:true,characterData:true,attributes:true});
      const error = this.root.querySelector('.product-form__error-message-wrapper');
      if (error) this.mutations.observe(error, {childList:true,subtree:true,characterData:true,attributes:true});
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.mutations?.disconnect();
      this.media?.removeEventListener('change', this.update);
      this.button?.removeEventListener('click', this.onClick);
    }
  });
})();
